// extracted by mini-css-extract-plugin
export default {"personWrapper":"Person_personWrapper__iA9nU","avatar":"Person_avatar__1iEM7","person":"Person_person__-wQ5h"};